import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { request } from "@/utils/api";

// Async thunk for fetching shipping charges
export const fetchShippingCharges = createAsyncThunk(
    "getShippingCharges/fetch",
    async (data, { rejectWithValue }) => {
        try {
            // Call the API to fetch shipping charges
            const response = await request({
                endpoint: "user/getShippingCharges", // Replace with your actual endpoint
                method: "GET",
                params: data,
            });

            console.log("Fetch Shipping Charges Response:", response);

            // Check if the fetch operation was successful
            if (!response.data.shippingCharges || !Array.isArray(response.data.shippingCharges)) {
                return rejectWithValue(response.message || "Failed to fetch shipping charges.");
            }

            // Return the fetched shipping charges
            return response.data.shippingCharges; // Assuming the response contains an array of charges
        } catch ({ error }) {
            console.error("Error fetching shipping charges:", error.message);
            return rejectWithValue(error.message || "An unexpected error occurred while fetching shipping charges.");
        }
    }
);

const initialState = {
    shippingCharges: [], // Array to store all shipping charges
    loading: false,
    error: null,
};

const shippingChargesSlice = createSlice({
    name: "shippingCharges",
    initialState,
    reducers: {
        addShippingCharges: (state, action) => {
            state.shippingCharges = action.payload;
        },
        clearShippingCharges: (state) => {
            state.shippingCharges = [];
            state.loading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            // Fetch Shipping Charges
            .addCase(fetchShippingCharges.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchShippingCharges.fulfilled, (state, action) => {
                state.loading = false;
                state.shippingCharges = action.payload; // Update the shipping charges array
            })
            .addCase(fetchShippingCharges.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload; // Store the error message
            });
    },
});

export const { clearShippingCharges, addShippingCharges } = shippingChargesSlice.actions;
export default shippingChargesSlice.reducer;